import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
import { getStylesMode } from 'ziphy-web-shared/basic/helpers';
import styles from './Icon.module.scss';
import { default as audio, ReactComponent as Audio } from './ui/audio.svg';
import { default as back, ReactComponent as Back } from './ui/back.svg';
import { default as bell, ReactComponent as Bell } from './ui/bell.svg';
import { default as burger, ReactComponent as Burger } from './ui/burger.svg';
import { default as calendarEvent2, ReactComponent as CalendarEvent2, } from './ui/calendar-event2.svg';
import { default as calendarEvent, ReactComponent as CalendrEvent } from './ui/calendar-event.svg';
import { default as calendar, ReactComponent as Calendar } from './ui/calendar.svg';
import { default as carTravel, ReactComponent as CarTravel } from './ui/car-travel.svg';
import { default as chat, ReactComponent as Chat } from './ui/chat.svg';
import { default as checkGreen, ReactComponent as CheckGreen } from './ui/check-green.svg';
import { default as check, ReactComponent as Check } from './ui/check.svg';
import { default as checks, ReactComponent as Checks } from './ui/checks.svg';
import { default as chevron, ReactComponent as Chevron } from './ui/chevron.svg';
import { default as clipboardList, ReactComponent as ClipboardList } from './ui/clipboard-list.svg';
import { default as close, ReactComponent as Close } from './ui/close.svg';
import { default as compass, ReactComponent as Compass } from './ui/compass.svg';
import { default as copy, ReactComponent as Copy } from './ui/copy.svg';
import { default as dashboard, ReactComponent as Dashboard } from './ui/dashboard.svg';
import { default as dnd, ReactComponent as Dnd } from './ui/dnd.svg';
import { default as documentRounded, ReactComponent as DocumentRounded, } from './ui/document-rounded.svg';
import { default as document, ReactComponent as Document } from './ui/document.svg';
import { default as down, ReactComponent as Down } from './ui/down.svg';
import { default as edit, ReactComponent as Edit } from './ui/edit.svg';
import { default as email, ReactComponent as Email } from './ui/email.svg';
import { default as exclamationPointYellow, ReactComponent as ExclamationPointYellow, } from './ui/exclamation-point-yellow.svg';
import { default as exclamationPoint, ReactComponent as ExclamationPoint, } from './ui/exclamation-point.svg';
import { default as eye, ReactComponent as Eye } from './ui/eye.svg';
import { default as filtersList, ReactComponent as FiltersList } from './ui/filters-list.svg';
import { default as geoscape, ReactComponent as Geoscape } from './ui/geoscape.svg';
import { default as heart, ReactComponent as Heart } from './ui/heart.svg';
import { default as home2, ReactComponent as Home2 } from './ui/home2.svg';
import { default as home, ReactComponent as Home } from './ui/home.svg';
import { default as image, ReactComponent as Image } from './ui/image.svg';
import { default as info, ReactComponent as Info } from './ui/info.svg';
import { default as linkArrow, ReactComponent as LinkArrow } from './ui/link-arrow.svg';
import { default as list, ReactComponent as List } from './ui/list.svg';
import { default as locationMarker, ReactComponent as LocationMarker, } from './ui/location-marker.svg';
import { default as location, ReactComponent as Location } from './ui/location.svg';
import { default as lockClosed, ReactComponent as LockClosed } from './ui/lock-closed.svg';
import { default as lockOpened, ReactComponent as LockOpened } from './ui/lock-opened.svg';
import { default as messageCircle, ReactComponent as MessageCircle, } from './ui/message-circle-2.svg';
import { default as moreDots, ReactComponent as MoreDots } from './ui/more-dots.svg';
import { default as moveLeftArrow, ReactComponent as MoveLeftArrow } from './ui/move-left-arrow.svg';
import { default as moveRightArrow, ReactComponent as MoveRightArrow, } from './ui/move-right-arrow.svg';
import { default as next, ReactComponent as Next } from './ui/next.svg';
import { default as notification, ReactComponent as Notification } from './ui/notification.svg';
import { default as pen, ReactComponent as Pen } from './ui/pen.svg';
import { default as pending, ReactComponent as Pending } from './ui/pending.svg';
import { default as phoneCall, ReactComponent as PhoneCall } from './ui/phone-call.svg';
import { default as phone, ReactComponent as Phone } from './ui/phone.svg';
import { default as pill, ReactComponent as Pill } from './ui/pill.svg';
import { default as plus, ReactComponent as Plus } from './ui/plus.svg';
import { default as rejected, ReactComponent as Rejected } from './ui/rejected.svg';
import { default as schedule, ReactComponent as Schedule } from './ui/schedule.svg';
import { default as scrollTop, ReactComponent as ScrollTop } from './ui/scroll-top.svg';
import { default as search, ReactComponent as Search } from './ui/search.svg';
import { default as settings2, ReactComponent as Settings2 } from './ui/settings2.svg';
import { default as settings, ReactComponent as Settings } from './ui/settings.svg';
import { default as stethoscope, ReactComponent as Stethoscope } from './ui/stethoscope.svg';
import { default as textMessage, ReactComponent as TextMessage } from './ui/text-message.svg';
import { default as trash, ReactComponent as Trash } from './ui/trash.svg';
import { default as tubes, ReactComponent as Tubes } from './ui/tubes.svg';
import { default as unknownWhite, ReactComponent as UnknownWhite } from './ui/unknown-white.svg';
import { default as unknown, ReactComponent as Unknown } from './ui/unknown.svg';
import { default as userCircle, ReactComponent as UserCircpe } from './ui/user-circle.svg';
import { default as user, ReactComponent as User } from './ui/user.svg';
import { default as users, ReactComponent as Users } from './ui/users.svg';
import { default as videoCall, ReactComponent as VideoCall } from './ui/video-call.svg';
import { default as voucher, ReactComponent as Voucher } from './ui/voucher.svg';
import { default as wallet, ReactComponent as Wallet } from './ui/wallet.svg';
const ICONS_COLLECTION = {
    audio: { img: audio, svg: Audio },
    back: { img: back, svg: Back },
    bell: { img: bell, svg: Bell },
    burger: { img: burger, svg: Burger },
    calendar: { img: calendar, svg: Calendar },
    carTravel: { img: carTravel, svg: CarTravel },
    check: { img: check, svg: Check },
    checks: { img: checks, svg: Checks },
    clipboardList: { img: clipboardList, svg: ClipboardList },
    close: { img: close, svg: Close },
    copy: { img: copy, svg: Copy },
    dnd: { img: dnd, svg: Dnd },
    documentRounded: { img: documentRounded, svg: DocumentRounded },
    document: { img: document, svg: Document },
    down: { img: down, svg: Down },
    edit: { img: edit, svg: Edit },
    email: { img: email, svg: Email },
    exclamationPoint: { img: exclamationPoint, svg: ExclamationPoint },
    filtersList: { img: filtersList, svg: FiltersList },
    geoscape: { img: geoscape, svg: Geoscape },
    home: { img: home, svg: Home },
    image: { img: image, svg: Image },
    info: { img: info, svg: Info },
    linkArrow: { img: linkArrow, svg: LinkArrow },
    list: { img: list, svg: List },
    locationMarker: { img: locationMarker, svg: LocationMarker },
    location: { img: location, svg: Location },
    moreDots: { img: moreDots, svg: MoreDots },
    moveLeftArrow: { img: moveLeftArrow, svg: MoveLeftArrow },
    moveRightArrow: { img: moveRightArrow, svg: MoveRightArrow },
    next: { img: next, svg: Next },
    notification: { img: notification, svg: Notification },
    phoneCall: { img: phoneCall, svg: PhoneCall },
    phone: { img: phone, svg: Phone },
    plus: { img: plus, svg: Plus },
    scrollTop: { img: scrollTop, svg: ScrollTop },
    search: { img: search, svg: Search },
    settings2: { img: settings2, svg: Settings2 },
    settings: { img: settings, svg: Settings },
    textMessage: { img: textMessage, svg: TextMessage },
    trash: { img: trash, svg: Trash },
    user: { img: user, svg: User },
    users: { img: users, svg: Users },
    videoCall: { img: videoCall, svg: VideoCall },
    voucher: { img: voucher, svg: Voucher },
    wallet: { img: wallet, svg: Wallet },
    unknown: { img: unknown, svg: Unknown },
    unknownWhite: { img: unknownWhite, svg: UnknownWhite },
    lockClosed: { img: lockClosed, svg: LockClosed },
    lockOpened: { img: lockOpened, svg: LockOpened },
    eye: { img: eye, svg: Eye },
    pen: { img: pen, svg: Pen },
    dashboard: { img: dashboard, svg: Dashboard },
    messageCircle: { img: messageCircle, svg: MessageCircle },
    calendarEvent: { img: calendarEvent, svg: CalendrEvent },
    chat: { img: chat, svg: Chat },
    pending: { img: pending, svg: Pending },
    exclamationPointYellow: { img: exclamationPointYellow, svg: ExclamationPointYellow },
    checkGreen: { img: checkGreen, svg: CheckGreen },
    tubes: { img: tubes, svg: Tubes },
    calendarEvent2: { img: calendarEvent2, svg: CalendarEvent2 },
    stethoscope: { img: stethoscope, svg: Stethoscope },
    pill: { img: pill, svg: Pill },
    heart: { img: heart, svg: Heart },
    compass: { img: compass, svg: Compass },
    chevron: { img: chevron, svg: Chevron },
    rejected: { img: rejected, svg: Rejected },
    home2: { img: home2, svg: Home2 },
    userCircle: { img: userCircle, svg: UserCircpe },
    schedule: { img: schedule, svg: Schedule },
};
const Icon = ({ tag = 'svg', mode, alt = '', type, className, color, size = 28, width = size, height = size, onClick, }) => {
    var _a;
    const isSvg = tag === 'svg';
    const entry = (_a = ICONS_COLLECTION[type]) !== null && _a !== void 0 ? _a : ICONS_COLLECTION.unknown;
    const SvgComp = entry.svg;
    if (isSvg && SvgComp) {
        return (_jsx(SvgComp, { width: width, height: height, className: classNames(mode && getStylesMode(mode, styles), className), color: color, onClick: onClick }));
    }
    if (entry.img) {
        return (_jsx("img", { src: entry.img, alt: alt, width: width, height: height, className: className, onClick: onClick }));
    }
    return null;
};
export default Icon;
